import {
  FileTextOutline,
  FileUpload,
  ImageOutline,
  LargeAudio,
  LargeFiles,
  LargePhoto,
  LargeText,
  LargeVideo,
  MicOutline,
  SmileyOutline,
  SparkleOutline,
  TextFill,
  VideoOutline,
} from '@lyearn/icons';
import { ResourceResponseTypeEnum } from '@/types/schema';

export default function getResponseTypeIcon(responseType?: ResourceResponseTypeEnum) {
  switch (responseType) {
    case ResourceResponseTypeEnum.Video:
      return LargeVideo;
    case ResourceResponseTypeEnum.File:
      return LargeFiles;
    case ResourceResponseTypeEnum.Image:
      return LargePhoto;
    case ResourceResponseTypeEnum.Text:
      return LargeText;
    case ResourceResponseTypeEnum.Audio:
      return LargeAudio;
    default:
      return FileUpload;
  }
}

export function getResponseTypeSmallIcon(responseType?: ResourceResponseTypeEnum) {
  switch (responseType) {
    case ResourceResponseTypeEnum.Video:
      return VideoOutline;
    case ResourceResponseTypeEnum.File:
      return FileTextOutline;
    case ResourceResponseTypeEnum.Image:
      return ImageOutline;
    case ResourceResponseTypeEnum.Text:
      return TextFill;
    case ResourceResponseTypeEnum.Audio:
      return MicOutline;
    case ResourceResponseTypeEnum.Any:
      return SparkleOutline;
    case ResourceResponseTypeEnum.Likert:
      return SmileyOutline;
    default:
      return FileTextOutline;
  }
}
